import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-group"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "gallery" }
const _hoisted_5 = { class: "galleryItem" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_file_input_multiple = _resolveComponent("file-input-multiple")!
  const _component_icon_chevron_left = _resolveComponent("icon-chevron-left")!
  const _component_icon_chevron_right = _resolveComponent("icon-chevron-right")!

  return (_ctx.localValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Carica nuova",
            text: "Carica nuova"
          })
        ]),
        _createElementVNode("div", null, [
          (this.entityIdentifier)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.refresher)
                  ? (_openBlock(), _createBlock(_component_file_input_multiple, {
                      key: 0,
                      modelValue: _ctx.filesToUpload,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filesToUpload) = $event))
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args))),
                  disabled: !_ctx.filesToUpload
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Carica",
                    text: "Carica"
                  })
                ], 8, _hoisted_2)
              ], 64))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "Salva prima di caricare allegati",
                text: "Salva prima di caricare allegati"
              }))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (item, i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "moveLeft",
                  onClick: ($event: any) => (_ctx.moveLeft(i))
                }, [
                  _createVNode(_component_icon_chevron_left)
                ], 8, _hoisted_6),
                _createElementVNode("img", {
                  src: item.publicUrl
                }, null, 8, _hoisted_7),
                _createElementVNode("button", {
                  class: "position-absolute btn btn-sm btn-danger deleteButton",
                  onClick: ($event: any) => (_ctx.removeImage(i))
                }, " x ", 8, _hoisted_8),
                _createElementVNode("button", {
                  class: "moveRight",
                  onClick: ($event: any) => (_ctx.moveRight(i))
                }, [
                  _createVNode(_component_icon_chevron_right)
                ], 8, _hoisted_9)
              ]))
            }), 256))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}